export default __webpack_public_path__ + "static/media/legends-image@2x.43a23e26.jpg";